import React from 'react';

import { useIntl } from 'react-intl';

import { AssetsIcon } from '@atlaskit/logo/assets/icon';
import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';
import { JiraIcon } from '@atlaskit/logo/jira-icon';
import { TalentIcon } from '@atlaskit/logo/talent/icon';

import { PrimaryProductKeys } from '../../../constants/primary-product-keys';
import { type PrimaryProductKey } from '../../../constants/product-keys';
import { i18n } from './messages';

export const FilterProductIcon = (props: {
	primaryProduct?: PrimaryProductKey;
	showPrimaryProductIcon?: boolean;
}): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const { showPrimaryProductIcon, primaryProduct } = props;

	if (!showPrimaryProductIcon || !primaryProduct) {
		return null;
	}

	if (primaryProduct === PrimaryProductKeys.Confluence) {
		return <ConfluenceIcon label={formatMessage(i18n.confluenceIconLabel)} size="xxsmall" />;
	}

	if (primaryProduct === PrimaryProductKeys.Jira) {
		return <JiraIcon label={formatMessage(i18n.jiraIconLabel)} size="xxsmall" />;
	}
	if (primaryProduct === PrimaryProductKeys.Assets) {
		return <AssetsIcon label={formatMessage(i18n.assetsIconLabel)} size="xxsmall" />;
	}

	if (primaryProduct === PrimaryProductKeys.Talent) {
		return <TalentIcon label={formatMessage(i18n.talentIconLabel)} size="xxsmall" />;
	}

	// Add more primary product icons here

	return null;
};
